import * as Styled from './pagination.style';
import IconDropdown from 'approot/shared/icons/icon-dropdown';

type Props = {
  currentPage: number;
  totalPageCount: number;
  labelPrefix?: string;
  isSmall?: boolean;
  allyName?: string;
  onNext: () => void;
  onPrevious: () => void;
};

const Pagination = ({
  currentPage,
  totalPageCount,
  labelPrefix,
  isSmall,
  allyName,
  onNext,
  onPrevious,
  ...rest
}: Props) => {
  return (
    <Styled.Pagination
      {...rest}
      aria-label={`${allyName ? `${allyName} pagination` : 'pagination'}`}
    >
      <Styled.PaginationButtons>
        <li>
          <Styled.PaginationPrev
            data-selector="pagination-previous"
            type="button"
            aria-label={`View page ${currentPage + 1}${
              allyName ? ` of ${allyName}` : ''
            }`}
            disabled={currentPage === 0}
            onClick={() => onPrevious()}
          >
            <IconDropdown width={15} height={15} />
          </Styled.PaginationPrev>
        </li>
        <Styled.PaginationTotal
          $isSmall={isSmall}
          data-selector="pagination-text"
        >
          {labelPrefix && `${labelPrefix} `}
          {totalPageCount === 0 ? 0 : currentPage + 1} of {totalPageCount}
        </Styled.PaginationTotal>
        <li>
          <Styled.PaginationNext
            data-selector="pagination-next"
            type="button"
            aria-label={`View page ${currentPage + 2}${
              allyName ? ` of ${allyName}` : ''
            }`}
            disabled={
              totalPageCount === 0 || currentPage === totalPageCount - 1
            }
            onClick={() => onNext()}
          >
            <IconDropdown width={15} height={15} />
          </Styled.PaginationNext>
        </li>
      </Styled.PaginationButtons>
    </Styled.Pagination>
  );
};

export default Pagination;
